import React, {useState} from "react";
import {inject, observer} from "mobx-react";

import {LLBtn, llNotifier} from "../../elements";
import {getCookie, removeCookie, setCookie, trans} from "../../../common/utils";
import ForgotPassPartOne from "./components/forgot-pass-part-one";
import ForgotPassPartTwo from "./components/forgot-pass-part-two";
import ForgotPassForbidden from "./components/forgot-pass-forbiden";


const commonInputProps = {
    labelPosition: 'inside',
    showClearButton: true,
    stylingMode: 'outlined',
};

const SimpleForgotPasswordForm = (
    {store}
) => {
    const viewSize = store.site.status.viewSize,
        forgotPasswordSMS = store.user.forgotPasswordSMS,
        forgotPasswordCode = store.user.forgotPasswordCode,
        closeModal = store.modal.close;

    const [formPart, setFormPart] = useState(getCookie('forgot-forbidden') ? 0 : 1),
        [isFetching, setFetching] = useState(false),
        [smsTimer, setSmsTimer] = useState(null),
        [canGetNewOne, setGetNewOne] = useState(false),
        [errors, setErrors] = useState({
            phone: '',
            code: ''
        }),
        [form, setForm] = useState({
            phone: '',
            code: ''
        });

    const currentPart = () => {
        const parts = {
            0: <ForgotPassForbidden setFormPart={setFormPart}/>,
            1: <ForgotPassPartOne commonInputProps={commonInputProps} form={form} setForm={setForm} errors={errors}
                                  setErrors={setErrors} viewSize={viewSize}
               />,
            2: <ForgotPassPartTwo commonInputProps={commonInputProps} form={form} setForm={setForm} errors={errors}
                                  setErrors={setErrors} forgotPassSubmit={forgotPassSubmit} smsTimer={smsTimer}
                                  viewSize={viewSize} canGetNewOne={canGetNewOne}
                                  setGetNewOne={setGetNewOne}
               />,
        }
        return parts[formPart]
    }

    const forgotPassSubmit = (getSMS = false) => {
        setFetching(true);

        const data = {
            phone: form.phone,
        };

        if (formPart === 2 && !getSMS) {
            data.code = form.code;

            forgotPasswordCode({...data}).then((response) => {
                if (!response?.success) {
                    if (response.data.attempts_available >= 3) {
                        llNotifier({
                            message:
                                'You entered the wrong code three times. A new code has been sent to you via SMS.',
                            type: 'error',
                        });
                        setForm({
                            ...form,
                            code: '',
                        });
                    }
                    if (response?.data?.error) {
                        llNotifier({
                            message: response?.data?.error || 'GENERAL_ERROR',
                            type: 'error',
                        });
                        if (response?.data?.error === 'WRONG_CODE') {
                            setErrors((v) => ({
                                ...v,
                                code: response?.data?.error,
                            }))
                        }
                    }
                } else {
                    closeModal();
                    llNotifier({
                        message:
                            'We will send a new password to you by SMS.',
                        type: 'success',
                    });
                }
                setFetching(false);
            });
            return;
        }

        forgotPasswordSMS({...data}).then((response) => {
            if (!response?.success) {
                if (response?.data?.description) {
                    const errorKeys = Object.keys(response.data.description);
                    if (errorKeys?.length) {
                        errorKeys.forEach((key) => {
                            if (errors[key] || errors[key] === '') {
                                setErrors((v) => ({
                                    ...v,
                                    [key]: response.data.description[key],
                                }))
                            }
                        });
                    }
                }
                if (response?.data?.error) {
                    llNotifier({
                        message: response?.data?.error,
                        type: 'error',
                    });
                    if (response?.data?.error === 'PHONE_ALREADY_USED') {
                        setErrors((v) => ({
                            ...v,
                            phone: response?.data?.error,
                        }))
                    }
                    if (response?.data?.error === 'TOO_MUCH_ATTEMPTS') {
                        setCookie('forgot-forbidden', Date.now() + response?.data?.timeout);
                        setFormPart(0);
                    }
                    if (response?.data?.error === 'CODE_ALREADY_SENT') {
                        setSmsTimer(response?.data?.timeout);
                        setFormPart(2);
                    }
                }
            } else {
                removeCookie('forgot-forbidden');
                setSmsTimer(null);
                setGetNewOne(false);
                setFormPart(2);
            }
            setFetching(false);
        });
    }

    return (
        <div className="simple-forgot-password-form">
            {currentPart()}
            <div className="simple-forgot-password__footer">
                {formPart !== 0 && <LLBtn
                    className="simple-forgot-password__button ll-btn--accent"
                    useSubmitBehavior={false}
                    disabled={isFetching || !form.phone || (formPart === 2 && !form.code) || !!errors.phone || !!errors.code}
                    onClick={() => {
                        if (!isFetching) {
                            forgotPassSubmit();
                        }
                    }}
                                   >
                    <div>
                        <span>{trans('Ok')}</span>
                    </div>
                </LLBtn>}
            </div>
        </div>
    );
}

export default inject('store')(observer(SimpleForgotPasswordForm));